import { AccountForm } from './AccountForm';

export function AccountNew() {
  return <AccountForm mode={{ kind: 'create' }} />;
}
